import { render, staticRenderFns } from "./UsageRing.vue?vue&type=template&id=383aa9de&scoped=true"
import script from "./UsageRing.vue?vue&type=script&lang=js"
export * from "./UsageRing.vue?vue&type=script&lang=js"
import style0 from "./UsageRing.vue?vue&type=style&index=0&id=383aa9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383aa9de",
  null
  
)

export default component.exports